import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { UserPreferencesProvider } from './context/UserPreferencesContext';
import PrivateRoute from './components/PrivateRoute';
import MainLayout from './components/MainLayout';
import Navbar from './components/Navbar';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardContent from './pages/DashboardContent';
import FocusPage from './pages/FocusPage';
import SettingsPage from './pages/SettingsPage';
import BoardPage from './pages/BoardPage';
import OverduePage from './pages/OverduePage';
import UnscheduledPage from './pages/UnscheduledPage';
import CompletedPage from './pages/CompletedPage';
import PlannerPage from './pages/PlannerPage';
import FocuslyAIPage from './pages/FocuslyAIPage';

function App() {
  return (
    <AuthProvider>
      <UserPreferencesProvider>
        <ThemeProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route
              element={
                <PrivateRoute>
                  <MainLayout />
                </PrivateRoute>
              }
            >
              <Route path="/" element={<DashboardContent />} />
              <Route path="/ai" element={<FocuslyAIPage />} />
              <Route path="/focus" element={<FocusPage />} />
              <Route path="/planner" element={<PlannerPage />} />
              <Route path="/board" element={<BoardPage />} />
              <Route path="/overdue" element={<OverduePage />} />
              <Route path="/unscheduled" element={<UnscheduledPage />} />
              <Route path="/completed" element={<CompletedPage />} />
              <Route path="/settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
        </ThemeProvider>
      </UserPreferencesProvider>
    </AuthProvider>
  );
}

export default App;
